import apiClient from './apiClient';

const API_URL = '/niveles-educativos'; // Asegurate que el backend corra en este puerto

// Obtener todos los niveles educativos
export const getNivelesEducativos = async () => {
    const response = await apiClient.get(API_URL);
    return response.data;
};

// Consultar nivel educativo por ID
export const getNivelEducativoPorId = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};
